@if (pfTitle) {
    <pf-text type="description">{{ pfTitle }}</pf-text>
}
@if (!dropdown) {
    <pf-segmented
        class="desktop"
        [segmentedOptions]="segmentedOptions"
        [model]="selectedIndex"
        (selectedModelChange)="handleIndexChange($event)"></pf-segmented>
}
<pf-select
    [ngClass]="{ laptop: !dropdown }"
    [data]="selectOptions"
    [control]="selectControl"
    (selected)="handleSelectChange($event.value)"></pf-select>
